import {
    FieldFormComponent as SourceFieldFormComponent,
} from 'SourceComponent/FieldForm/FieldForm.component';
import React from 'react';
import './FieldForm.override.style';
import Field from 'Component/Field';
import FieldGroup from '@scandipwa/scandipwa/src/component/FieldGroup';

export class FieldFormComponent extends SourceFieldFormComponent {
    renderSection(section) {
        if ('fields' in section) {
            const { name: sectionName, attr: { name } = {}, fields } = section;

            return (
                <FieldGroup {...section} key={name || sectionName}>
                    {fields.map(this.renderSection.bind(this))}
                </FieldGroup>
            );
        }

        const { attr: { name } = {} } = section;

        if (this?.props?.shippingAddress) {
            const { shippingAddress } = this.props;
            const data = { ...section, attr: { ...section.attr, defaultValue: shippingAddress[name] } }

            if (shippingAddress?.street && shippingAddress?.street?.length) {
                if (name === "street_0" && shippingAddress?.street?.length > 0) {
                    const stretfield = { ...section, attr: { ...section.attr, defaultValue: shippingAddress?.street[0] } }

                    return <Field {...stretfield} key={name} />;
                }

                if (name === "street_1" && shippingAddress?.street?.length > 1) {
                    const stretfield = { ...section, attr: { ...section.attr, defaultValue: shippingAddress?.street[1] } }

                    return <Field {...stretfield} key={name} />;
                }
            }

            return <Field {...data} key={name} />;
        }

        return <Field {...section} key={name} />;
    }
}

export default FieldFormComponent;
